import React, {Component} from "react";
import * as Utils from "../../../Utils";
import * as HomeworkService from "../../../../services/Student/HomeworkService";
import {Redirect} from "react-router-dom";

class Homework extends Component {
    state = {
        data: {},
        readingPlayCount: 1,
        readingTitle: '',
        readingSection: '',
        readingContents: '',
        readingContentsBlank: '',
        readingVocabList: new Map(),
        readingResult: new Map(),
        isPageRedirect: false,
        readingSentenceFileName: '',
        audio: null,
        blankVocabYScroll: 0,
        blankVocabClickValue: '',
        isDisplayVocabBox: true,
        audioPlaying: false,
        audioPlayCnt: 0
    };

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        this.getReadingHomework(Utils.getDate(), params.get('section'), params.get('title'));
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener("popstate", this.handleBackButton); // Listen to the popstate event
    }

    componentWillUnmount() {
        if (this.state.audio) {
            this.state.audio.pause();
        }
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("popstate", this.handleBackButton);
    };

    handleScroll = () => {
        this.setState({
            blankVocabYScroll: window.scrollY
        });
    };
    handleBackButton = () => {
        this.redirectToHomeworkPage();
    };
    redirectToHomeworkPage = () => {
        window.location.href = '/app/reading';
    };

    audioFullReadingPlay = () => {
        const that = this
        this.audioPlayStart();
        const {data} = this.state;
        if (data && data.reading && data.reading.fileName) {
            this.setState({
                audio: new Audio("https://beacon.beacon-edu.co.kr/beacon-tts-reading/".concat(data.reading.fileName))
            });
            if (this.state.audio) {
                this.state.audio.play().then().catch(item => {
                    console.log('audio 404')
                    return false;
                });
                that.state.audio.onended = () => {
                    that.audioPlayEnd();
                };
            }
        }
    };

    audioFullReadingRePlay = () => {
        const that = this
        this.audioPlayStart();
        if (this.state.audio) {
            this.state.audio.play().then().catch(item => {
                console.log('audio 404')
                return false;
            });
            that.state.audio.onended = () => {
                that.audioPlayEnd();
            };
        }
    };

    audioSentenceClickPlay = () => {
        if (this.state.audioPlaying === false) {
            const that = this
            this.audioPlayStart();
            this.setState({
                audio: new Audio("https://beacon.beacon-edu.co.kr/beacon-tts-reading/".concat(this.state.readingSentenceFileName))
            });
            // let audio = new Audio("https://beacon.beacon-edu.co.kr/beacon-tts-reading/".concat(text));
            this.state.audio.play().then().catch(item => {
                console.log('audio 404')
                return false
            });
            that.state.audio.onended = () => {
                this.audioPlayEnd();
            };
        }
    };

    shuffle(data) {
        const dataKeys = Object.keys(data).sort(() => Math.random() - 0.5);
        const shuffleData = []
        dataKeys.forEach(key => {
            shuffleData.push(data[key]);
        });
        return shuffleData
    };

    getReadingHomework = (date, section, title) => {
        const that = this;
        this._isMounted = true;
        HomeworkService.getReadingHomework(date, section, title).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    if (that._isMounted) {
                        that.setState({
                            data: response.data.data,
                            isDisplayVocabBox: response.data.data.hwDone,
                            readingTitle: response.data.data.reading.title,
                            readingSection: response.data.data.reading.section,
                            readingContents: response.data.data.reading.contents,
                            readingContentsBlank: response.data.data['readingBlank'],
                            readingVocabList: this.shuffle(response.data.data.vocab),
                            readingSentenceFileName: ''
                        });
                        that.audioFullReadingPlay();
                    }
                } else {
                    window.location.href = '/app/homework';
                }
            } else {
                console.log(response);
                alert('LOGIN ERROR');
                this.audioPlayEnd();
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
            this.audioPlayEnd();
        });
    }

    contentOnClick = (index) => {
        if (this.state.audioPlaying === true) {
            return false;
        }
        const splitFromOriginReadingContent = this.state.readingContents.split("\.");
        const readingContent = splitFromOriginReadingContent[index] + "."
        const readingFileNameTemp = readingContent.replaceAll(" ", "_");
        const readingFileName = readingFileNameTemp.replaceAll(/[^a-zA-Z]/g, '_');
        let createReadingSentenceMap = {
            fileName: readingFileName,
            sentence: readingContent,
        };
        const that = this;
        HomeworkService.createReadingSentence(createReadingSentenceMap).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    that.setState({
                        readingSentenceFileName: response.data.data.fileName
                    });
                    that.audioSentenceClickPlay();
                } else {
                    window.location.href = '/app/homework';
                }
            } else {
                console.log(response);
                alert('SERVER ERROR');
                this.audioPlayEnd();
            }
        }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
            this.audioPlayEnd();
        });
    }

    audioPlayStart = () => {
        this.setState({
            audioPlaying: true
        });
    };

    audioPlayEnd = () => {
        this.setState({
            audioPlaying: false
        });
    };

    blankFieldInput = (dotIndex, index, value) => {
        const {readingResult} = this.state;
        const key = dotIndex + '' + index;
        const newReadingResult = new Map(readingResult);
        newReadingResult.set(key, value.toLowerCase());
        this.setState({
            readingResult: newReadingResult,
        });
    };

    nextOrReport = () => {
        if (this.state.audioPlaying) {
            alert('Audio is playing');
            return false;
        }

        if (this.state.readingPlayCount > this.state.audioPlayCnt) {
            this.setState({
                audioPlayCnt: 1 + this.state.audioPlayCnt,
            });
            this.audioFullReadingRePlay();
        } else {
            this.saveReport();
        }
    }

    saveReport() {
        const {data, readingResult} = this.state;
        const totalNum = Object.keys(data.vocab).length;
        let correctNum = 0;

        let readingResultKeys = [];
        for (let key of readingResult.keys()) {
            readingResultKeys.push(key);
        }
        readingResultKeys = readingResultKeys.sort(function (a, b) {
            return a - b;
        });
        let readingResultArray = [];
        readingResultKeys.forEach(key => {
            readingResultArray.push(readingResult.get(key));
        });
        const dataVocabKeys = Object.keys(data.vocab).sort(function (a, b) {
            return a - b;
        });
        for (let index = 0; totalNum > index; index++) {
            let correctVocab = data.vocab[dataVocabKeys[index]];
            let answerVocab = readingResultArray[index];
            if (answerVocab != null
                && correctVocab.trim().toLowerCase() === answerVocab.trim().toLowerCase()) {
                correctNum++;
            }
        }
        const percentage = (correctNum / totalNum) * 100;
        const report = {
            "homeworkId": data.homeworkId,
            "subject": "reading",
            "studentPoint": "",
            "totalExamNum": Object.keys(data.vocab).length,
            "correctNum": correctNum,
            "percentage": percentage,
            "studentVocabPoint": "",
            "description": "",
            "homeworkDueDate": Utils.getDate()
        };
        HomeworkService.reportReading(report).then(
            (response) => {
                if (response !== null && response.status === 200) {
                    // 데이터 저장 성공
                    if (response.data !== null && response.data.code === '0000') {
                        this.getTodayHomework(Utils.getDate());
                        alert('Reading 점수는 : ' + report.percentage + '점');
                    } else {
                        alert(response.data.data);
                    }
                } else {
                    console.log(response);
                    alert('LOGIN ERROR');
                }
            }).catch(response => {
            console.log(response);
            alert('SERVER ERROR');
        });
    }

    getTodayHomework = (date) => {
        HomeworkService.getHomework(date).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    const list = responseData.data.filter((x) => x.doneData == null); //남은 숙제 검색
                    this.setState({
                        isPageRedirect: true,
                        url: (list.length === 0) ? "/app/calendar" : "/app/homework"
                    });
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('SERVER ERROR');
            }
        });
    }

    dragStart = (e) => {
        e.dataTransfer.setData("Text", (e.currentTarget.textContent).toLowerCase());
    };
    dragEnd = (e) => {
        e.preventDefault();
    };
    dragOver = (e) => {
        e.preventDefault();
    };
    dragDrop = (dotIndex, index, e) => {
        e.preventDefault();
        e.stopPropagation();
        const {readingResult} = this.state;
        const value = e.dataTransfer.getData("Text")
        const key = dotIndex + '' + index;
        const newReadingResult = new Map(readingResult);
        newReadingResult.set(key, value);
        this.setState({
            readingResult: newReadingResult,
        });
    };
    blankInputFieldClick = (dotIndex, index, e) => {
        e.preventDefault();
        e.stopPropagation()
        if (this.state.blankVocabClickValue !== null && this.state.blankVocabClickValue !== '') {
            const {readingResult} = this.state;
            const key = dotIndex + '' + index;
            const newReadingResult = new Map(readingResult);
            newReadingResult.set(key, this.state.blankVocabClickValue);
            this.setState({
                readingResult: newReadingResult,
                blankVocabClickValue: ''
            });
        }
    }
    blankVocabClick = (e) => {
        e.preventDefault();
        this.setState({
            blankVocabClickValue: (e.currentTarget.textContent).toLowerCase()
        });
    }


    blankField = (dotIndex, index, splitDisplayContent) => {
        const {readingResult} = this.state;
        if (splitDisplayContent.length - 1 > index) {
            return (
                <input key={`input${index}`}
                       style={{
                           border: `${this.state.blankVocabClickValue !== '' ? '2px solid #f9c050' : ''}`
                       }}
                       value={readingResult.get(dotIndex + '' + index) || ""}
                       onDragOver={e => this.dragOver(e)}
                       onDrop={e => this.dragDrop(dotIndex, index, e)}
                       onChange={e => this.blankFieldInput(dotIndex, index, e.target.value)}
                       onClick={e => this.blankInputFieldClick(dotIndex, index, e)}/>
            );
        } else {
            return ('');
        }
    }

    displayReadingContent = () => {
        const {isPageRedirect, readingContents, url} = this.state;
        if (isPageRedirect) {
            return <Redirect to={url}/>
        }
        return (
            <span style={{display: 'inline', fontSize: '15pt'}}>
                {readingContents}
            </span>
        );
    };

    displayReadingBlankContent = () => {
        const {readingContentsBlank, isPageRedirect, url} = this.state;
        if (isPageRedirect) {
            return <Redirect to={url}/>
        }
        let splitContentByDot = readingContentsBlank.split('\.');
        return (
            <span style={{display: 'inline', fontSize: '15pt', cursor: 'pointer'}}>
                {splitContentByDot.map((contentByDot, dotIndex) => {
                    if (contentByDot != null && contentByDot.trim() !== '') {
                        let splitDisplayContent = contentByDot.split('_blankWord_');
                        return (
                            <div key={'contentByDot' + dotIndex} style={{display: 'inline'}}
                                 onClick={() => this.contentOnClick(dotIndex)}>
                                {/*{contentByDot}.*/}
                                <span style={{display: 'inline', fontSize: '15pt', cursor: 'pointer'}}>
                                    {splitDisplayContent.map((content, index) => {
                                        return (
                                            <div key={index} style={{display: 'inline'}}>
                                                {content}
                                                {this.blankField(dotIndex, index, splitDisplayContent)}
                                            </div>
                                        );
                                    })}.&nbsp;
                                </span>
                            </div>
                        );
                    }
                })}&nbsp;
            </span>
        );
    };

    blankVocabBtn = () => {
        if (Object.keys(this.state.readingVocabList).length > 0) {
            return (
                <span>
                    {this.state.readingVocabList.map((value, index) =>
                        <div key={`draggable${index}`} draggable={true}
                             onClick={(e) => this.blankVocabClick(e)}
                             onDragStart={(e) => this.dragStart(e)}
                             onDragEnd={(e) => this.dragEnd(e)}>
                            <div key={value + index} style={{marginTop: "10px", float: "left"}}>
                                <a className={
                                    `baseBtn 
                                    ${this.state.blankVocabClickValue !== ''
                                    && this.state.blankVocabClickValue === value ? 'yellow' : 'blue'}`
                                }>
                                    <span style={{textTransform: "lowercase", fontSize: "120%"}}>
                                        {value}
                                    </span>
                                </a>
                            </div>

                        </div>
                    )}
                </span>
            )
        }
    }

    nextOrDoneBtn = () => {
        let value
        if (this.state.readingPlayCount > this.state.audioPlayCnt) {
            value = 'Next'
        } else {
            value = 'Done'
        }

        return (
            <div>
                <div onClick={() => this.nextOrReport()} style={{
                    marginTop: "10px",
                    float: "right"
                }}>
                    <a className="baseBtn loginOrange">
                        <span>{value}</span>
                    </a>
                </div>
            </div>
        );
    }

    blankVocabContent = () => {
        return (
            <div id="blankVocab" style={{
                width: '100%',
                display: this.state.isDisplayVocabBox ? 'block' : 'none',
                position: 'relative',
                top: `${this.state.blankVocabYScroll}px`,
                zIndex: 9999
            }}>
                {this.blankVocabBtn()}
            </div>
        )
    }

    readingBody = () => {
        let readingContent
        let vocabContent = ''

        if (this.state.readingPlayCount > this.state.audioPlayCnt) {
            readingContent = this.displayReadingContent();
        } else {
            vocabContent = this.blankVocabContent();
            readingContent = this.displayReadingBlankContent();
        }

        return (
            <div className="homeworkWrapper">
                {vocabContent}
                <div className="reading-category reading off" style={{
                    width: "100%", textAlign: "left", lineHeight: 2.5, height: "auto"
                }}>
                    <h3 className="screenOut">reading</h3>
                    <dl className="categoryBox">
                        <dt className="title">
                            <span>reading</span>
                        </dt>
                        <dd className="contents">
                            {readingContent}
                        </dd>
                    </dl>
                </div>
                {this.nextOrDoneBtn()}
            </div>
        )
    }

    render() {
        return (
            <div className="contentsWrapper">
                <h2 className="screenOut">오늘의 숙제</h2>
                {this.readingBody()}
            </div>
        );
    }
}

Homework.defaultProps = {};

export default Homework;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Reading/Homework.js